// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fsLdw","icon":"styles_icon__uGrFj"};